import { render, staticRenderFns } from "./DesignPortfolioSuggestions.vue?vue&type=template&id=098f89f6&"
import script from "./DesignPortfolioSuggestions.vue?vue&type=script&lang=js&"
export * from "./DesignPortfolioSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./DesignPortfolioSuggestions.vue?vue&type=style&index=0&id=098f89f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports